import PropTypes from 'prop-types'
import React from 'react'

const BuyTextInput2 = ({
  dataCy,
  label,
  placeholder,
  type,
  tooltip,
  update,
  classes,
  disabled,
  labelStyle,
  isSymbol,
  theSymbol,
  onInput,
  value,
}) => {
  const tip = _tooltip =>
    _tooltip ? (
      <div className="help-label left">
        <span className="help-tip" key={'tip'}>
          {_tooltip}
        </span>
      </div>
    ) : null
  return (
    <div className={isSymbol}>
      <input
        className={classes}
        data-cy={dataCy}
        data-hj-suppress
        disabled={disabled || false}
        key={'input'}
        onBlur={update}
        onChange={update}
        onInput={onInput}
        onWheel={event => {
          if (event.target && type === 'number') {
            event.target.blur()
          }
        }}
        placeholder={placeholder}
        type={type || 'text'}
        value={value || ''}
      />
      <label className="label" key={'label'} style={labelStyle}>
        {label}
      </label>
      <span className="symbol">{theSymbol}</span>
      {tip(tooltip)}
    </div>
  )
}
BuyTextInput2.defaultProp = {
  onInput: null,
}

BuyTextInput2.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onInput: PropTypes.func,
  update: PropTypes.func.isRequired,
  verify: PropTypes.bool,
  disabled: PropTypes.bool,
  tooltip: PropTypes.array,
  type: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
}

export default BuyTextInput2
